export const isDevProfileSwitcherEnabled =
	process.env.NODE_ENV === "development" && process.env["REACT_APP_ENV"] === "development" && process.env["REACT_APP_DEV_AUTH_ENABLED"] === "true";
